export { default as CopyTerritoryModal } from './CopyTerritoryModal';
